import { ObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';

export function makeIdentifierKey(
  objectTypeId: ObjectTypeId,
  propertyName: string,
  objectId: string
): string {
  return `${objectTypeId}/${propertyName}/${objectId}`;
}

export function parseIdentifierKey(key: string): {
  objectTypeId: ObjectTypeId;
  propertyName: string;
  objectId: string;
} {
  const [objectTypeId, propertyName, objectId] = key.split('/');
  return { objectTypeId, propertyName, objectId };
}
